import { useTranslation } from "react-i18next";
import ImagePicker from "UIKit/ImagePicker/ImagePicker";
import useImageBank from "Hooks/useImageBank";

interface SpaceImageProps {
  onChangeBlob: (file: File | null) => void;
  onChangeImageUrl: (imageUrl: string) => void;
}
const SpaceImage = ({ onChangeBlob, onChangeImageUrl }: SpaceImageProps) => {
  const { t } = useTranslation();

  const { imageBank, imageBankLoading } = useImageBank();

  return (
    <ImagePicker
      galleryImages={imageBank}
      errorDraggedImageText={t("imagePicker_too_large_error")}
      isLoading={imageBankLoading}
      onChangeBlob={onChangeBlob}
      onChangeImageUrl={onChangeImageUrl}
      cropperAspectRatio={4}
    />
  );
};

export default SpaceImage;
